<template>
    <section class="news-data">
        <img :src="'https://tablet.esesja.pl/media/'+ data.id +'.jpg'" class="news-data__thumbnail" />
        <section>
            <h5 class="news-data__title" @click="goToNews(data.link)" style="cursor:pointer"> {{ data.title }} </h5>
            <section class="news-data__wrapper">
                <img class="news-data__icon" src="../../../../../assets/icons/panel/home/callendar-gray.svg" />
                <span class="news-data__date">{{ formatDateToDisplay(data.date, "dayMonthTextYear") }}</span>
            </section>
            <section v-if="withTeaser" class="news-data__news-teaser">{{data.teaser}}</section>
        </section>
    </section>
</template>

<script charset="utf-8">
import { formatDateToDisplay } from '../../../../../helpers/i18n.utils';
export default {
    name: "Information",
    props: {
        data: Object,
        withTeaser: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToNews(item){
            window.open(item, "_blank");
        },
        formatDateToDisplay
    }
};
</script>

<style lang="scss" scoped>
    .news-data {
        margin: 0px 16px;
        padding: 28px 0px;
        border: 0px;
        border-radius: 0px;
        border-bottom: 1px solid #dce4ee;
        display: flex;
        align-items: center;

        &__thumbnail {
            width: 119px;
            margin-right: 24px;
        }

        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 132%;
            color: #00082c;
        }

        &__wrapper {
            display: flex;
            align-items: center;
            margin-top: 10px;
        }

        &__date {
            font-weight: 500;
            font-size: 12px;
            line-height: 145%;
            color: #666b80;
            margin-left: 8px;
        }

        &__news-teaser {
            font-size: 12px;
            margin-top: 8px;
            text-align: justify;
        }
    }
</style>
